import { GeneralInformation } from "../../constants/aquafina";
import { RangeIterator } from "../../utils";
import { CoverageRow, NotProvidedRow } from "../table/rows";
import { CoverageCell } from "../table/cells";

import CollapsableSection from "./collapsable-section";

type GeneralInfoProps = {
  data: GeneralInformation[];
  showFundingType?: boolean;
  hideParticipationRequirement?: boolean;
  hideNetworkProviderName?: boolean;
  cellColSpan?: number;
};

const ProposalGeneralInfo = ({
  data,
  showFundingType = false,
  hideParticipationRequirement = false,
  hideNetworkProviderName = false,

  cellColSpan = 1,
}: GeneralInfoProps) => (
  <CollapsableSection
    numberOfColumns={data.length * cellColSpan}
    title="General Information"
    hasSeparator={false}
  >
    <ProposalGeneralInfoData
      data={data}
      showFundingType={showFundingType}
      hideParticipationRequirement={hideParticipationRequirement}
      hideNetworkProviderName={hideNetworkProviderName}
      cellColSpan={cellColSpan}
    />
  </CollapsableSection>
);

const ProposalGeneralInfoData = ({
  data,
  showFundingType = false,
  hideParticipationRequirement = false,
  hideNetworkProviderName = false,

  cellColSpan = 1,
}: GeneralInfoProps) => {
  if (data.every((d) => d === null)) {
    return <NotProvidedRow colSpan={data.length * cellColSpan} />;
  }

  return (
    <>
      {showFundingType && (
        <CoverageRow label="Funding Type" isWhite>
          {RangeIterator(data.length, (index) => (
            <CoverageCell
              value={data[index].fundingType}
              key={index}
              colSpan={cellColSpan}
            />
          ))}
        </CoverageRow>
      )}
      <CoverageRow label="Benefit Eligibility Classes">
        {RangeIterator(data.length, (index) => (
          <CoverageCell
            value={data[index].benefitClasses}
            key={index}
            colSpan={cellColSpan}
          />
        ))}
      </CoverageRow>
      <CoverageRow label="Rate Guarantee" isWhite>
        {RangeIterator(data.length, (index) => (
          <CoverageCell
            value={data[index].rateGuarantee}
            key={index}
            colSpan={cellColSpan}
          />
        ))}
      </CoverageRow>
      {!hideParticipationRequirement && (
        <CoverageRow label="Participation Requirement">
          {RangeIterator(data.length, (index) => (
            <CoverageCell
              value={data[index].participationRequirement}
              key={index}
              colSpan={cellColSpan}
            />
          ))}
        </CoverageRow>
      )}
      {!hideNetworkProviderName && (
        <CoverageRow label="Network" isWhite={!hideParticipationRequirement}>
          {RangeIterator(data.length, (index) => (
            <CoverageCell
              value={data[index].networkProvider}
              key={index}
              colSpan={cellColSpan}
            />
          ))}
        </CoverageRow>
      )}
    </>
  );
};

export default ProposalGeneralInfo;
